export enum FilterType {
  DATE = 'date',
  SELECT = 'select',
  SEARCH = 'search',
}
